import React, { useEffect, useState } from "react";
import { Table, Button, Spinner, Alert } from "react-bootstrap";
import axios from "axios";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";

export default function ViewHedgeRateMaster({ organisationIdProp }) {
  // if parent passes organisationIdProp it will be used, otherwise from auth
  const { user } = useAuth();
  const organisationId = organisationIdProp ?? user?.organisationId;

  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRates = async () => {
    if (!organisationId) {
      setError("Organisation Id missing.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(`${Base_URL}/HedgeRate/GetAllRates?id=${organisationId}`);
      // expecting an array like the sample you provided
      setRates(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Failed to fetch hedge rates", err);
      setError(err?.response?.data || err.message || "Failed to fetch hedge rates");
      setRates([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organisationId]);

  const fmtDate = (iso) => {
    if (!iso) return "";
    try {
      const d = new Date(iso);
      return d.toLocaleDateString(); // local format
    } catch {
      return iso;
    }
  };

  const fmtTime = (t) => {
    if (!t) return "";
    // t might be like "13:22:53"
    return t;
  };

  return (
    <div className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>View Hedge Rate Master</h4>
        <div>
          <Button variant="outline-primary" size="sm" onClick={fetchRates} disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : "Refresh"}
          </Button>
        </div>
      </div>

      {error && <Alert variant="danger">{String(error)}</Alert>}

      {!loading && rates.length === 0 && !error && (
        <div className="text-muted">No hedge rates found for Organisation Id: {organisationId}</div>
      )}

      <div style={{ overflowX: "auto" }}>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>HedgeRateId</th>
              <th>Country Code</th>
              <th>Exchange Rate</th>
              <th>Effective From</th>
              <th>Organisation Id</th>
              <th>Company Code</th>
              <th>Created By</th>
              <th>Created Date</th>
              <th>Created Time</th>
              <th>Timezone</th>
              <th>Changed By</th>
              <th>Changed Date</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            {rates.map((r, idx) => (
              <tr key={r.hedgeRateId ?? idx}>
                <td>{idx + 1}</td>
                <td>{r.hedgeRateId}</td>
                <td>{r.hedgeRateCountryCode}</td>
                <td>{r.hedgeExchangeRate}</td>
                <td>{fmtDate(r.effectiveFromDate)}</td>
                <td>{r.organisationId}</td>
                <td>{r.companyCode}</td>
                <td>{r.createdBy}</td>
                <td>{fmtDate(r.createdDate)}</td>
                <td>{fmtTime(r.createdTime)}</td>
                <td>{r.createdTimezone}</td>
                <td>{r.changedBy ?? "-"}</td>
                <td>{r.changedDate ? fmtDate(r.changedDate) : "-"}</td>
                <td>{r.active ? "Yes" : "No"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
